import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const LANGUAGES: { code: string; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' },
  { code: 'ru', label: 'Русский' },
  { code: 'zh', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'bn', label: 'বাংলা' },
];

const resources = {
  en: {
    translation: {
      nav: { about: 'About', experience: 'Experience', contact: 'Contact' },
      aria: {
        toggleNav: 'Toggle navigation',
        mainNav: 'Main navigation',
        selectLanguage: 'Select language',
        switchToLight: 'Switch to light mode',
        switchToDark: 'Switch to dark mode',
      },
      about: {
        role: 'Software Engineer',
        bio1: 'Experienced in taking complex, cross-team projects from early ideation through to production at scale.',
        viewExperience: 'View experience',
        getInTouch: 'Get in touch',
      },
      experience: {
        heading: 'Experience',
        present: 'Present',
        facebookTitle: 'Software Engineer',
        otherExperience: 'Other Experience',
        getInTouch: 'Get in touch',
        personalPortfolio: 'Personal portfolio',
        portfolio: 'This website!',
        moreDetails: 'More details',
        lessDetails: 'Less details',
        uber: 'Frontend tech lead for Nova Studio shaping the development of tools to author, test, and observe multi-surface AI-powered workflows across the suite of Uber apps.',
        facebook: 'Built and optimized flows for shops to showcase their products on marketplace and Facebook posts.',
        uberDetail1: 'Program lead for AutoPlay, the unified observability tool that enables discovering, playing back and debugging multi-surface, platform agnostic customer support sessions across the suite of apps',
        uberDetail2: 'Drove high level platform direction influencing strategy and standards across 30+ projects',
        uberDetail3: 'Performed progressive migration of playback and debugging details to support new execution technologies while maintaining backwards compatibility with legacy deterministic automations',
        uberDetail4: 'Multiplied impact by migrating playback code to a reusable fusion plugin enabling 6 other projects to seamlessly integrate',
        uberDetail5: 'Drove service upgrades, oncall processes, system design standards, and impact tracking to enhance development across projects',
        metaDetail1: 'Collaborated with design, data science, and engineers across Facebook to unblock large-scale projects and crowdsource solutions',
        metaDetail2: 'Performed user experiments with A/B testing leveraging logging infrastructure and UX considerations to determine outcomes',
        metaDetail3: 'Managed features from ideation and opportunity sizing through design and development to production',
        metaDetail4: 'Developed across various codebases including backend (hack) web (react), mobile (react native) and ios (objective-c)',
        metaDetail5: 'Architected the core logging abstraction for our team ensuring payload consistency and ease of use across all platforms and features',
        artInTheCape: 'Designed and architected an e-commerce website for gallery purchases and event ticketing.',
        menten: 'Built internal tools to increase the efficiency of the sales team.',
        cleanSlate: 'Created and maintained a consulting website.',
        engineersWeek: 'Built and deployed a registration and informational website.',
      },
      contact: {
        heading: 'Contact',
        intro: 'Matthew is always open to interesting conversations, collaborations, or new opportunities.',
        linkedin: 'LinkedIn',
        email: 'Email',
        github: 'GitHub',
        sendEmail: 'Send email',
        visit: 'Visit',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  es: {
    translation: {
      nav: { about: 'Sobre mí', experience: 'Experiencia', contact: 'Contacto' },
      aria: {
        toggleNav: 'Alternar navegación',
        mainNav: 'Navegación principal',
        selectLanguage: 'Seleccionar idioma',
        switchToLight: 'Cambiar a modo claro',
        switchToDark: 'Cambiar a modo oscuro',
      },
      about: {
        role: 'Ingeniero de Software Frontend',
        bio1: 'Experiencia liderando proyectos complejos y multidisciplinarios desde la ideación inicial hasta producción a escala.',
        viewExperience: 'Ver experiencia',
        getInTouch: 'Contáctame',
      },
      experience: {
        heading: 'Experiencia',
        present: 'Actualidad',
        facebookTitle: 'Ingeniero de Producto',
        otherExperience: 'Otra Experiencia',
        getInTouch: 'Contáctame',
        personalPortfolio: 'Portafolio personal',
        portfolio: '¡Este sitio web!',
        moreDetails: 'Más detalles',
        lessDetails: 'Menos detalles',
        uber: 'Líder técnico frontend del equipo que desarrolla herramientas para crear, probar y observar flujos automatizados con IA en la suite de aplicaciones de Uber.',
        facebook: 'Desarrollé y optimicé flujos para que las tiendas muestren sus productos en el marketplace y en publicaciones de Facebook.',
        uberDetail1: 'Líder de programa para AutoPlay, la herramienta de observabilidad unificada que permite descubrir, reproducir y depurar sesiones de soporte al cliente multi-superficie e independientes de la plataforma en toda la suite de aplicaciones',
        uberDetail2: 'Impulsé la dirección estratégica a alto nivel influenciando la estrategia y los estándares en más de 30 proyectos',
        uberDetail3: 'Realicé una migración progresiva de detalles de reproducción y depuración para soportar nuevas tecnologías de ejecución manteniendo compatibilidad hacia atrás con automatizaciones determinísticas heredadas',
        uberDetail4: 'Multipliqué el impacto al migrar el código de reproducción a un complemento de fusión reutilizable que permitió que 6 proyectos se integraran sin problemas',
        uberDetail5: 'Impulsé actualizaciones de servicio, procesos de oncall, estándares de diseño de sistemas y seguimiento de impacto para mejorar el desarrollo en todos los proyectos',
        metaDetail1: 'Colaboré con equipos de diseño, ciencia de datos e ingeniería en Facebook para desbloquear proyectos a gran escala y aprovechar soluciones colectivas',
        metaDetail2: 'Realicé experimentos de usuarios con pruebas A/B aprovechando la infraestructura de registro y consideraciones de UX para determinar resultados',
        metaDetail3: 'Gestioné funciones desde la ideación y dimensionamiento de oportunidades hasta el diseño, desarrollo y producción',
        metaDetail4: 'Desarrollé en varios códigos base incluyendo backend (hack) web (react), móvil (react native) e ios (objective-c)',
        metaDetail5: 'Diseñé la abstracción de registro central para nuestro equipo garantizando consistencia de carga útil y facilidad de uso en todas las plataformas y funciones',
        artInTheCape: 'Diseñé y arquitecté un sitio web de comercio electrónico para compras de la galería y venta de entradas a eventos.',
        menten: 'Desarrollé herramientas internas para aumentar la eficiencia del equipo de ventas.',
        cleanSlate: 'Creé y mantuve un sitio web de consultoría.',
        engineersWeek: 'Desarrollé y desplegué un sitio web de registro e información.',
      },
      contact: {
        heading: 'Contacto',
        intro: 'Matthew siempre está abierto a conversaciones interesantes, colaboraciones u oportunidades nuevas.',
        linkedin: 'LinkedIn',
        email: 'Correo electrónico',
        github: 'GitHub',
        sendEmail: 'Enviar correo',
        visit: 'Visitar',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  fr: {
    translation: {
      nav: { about: 'À propos', experience: 'Expérience', contact: 'Contact' },
      aria: {
        toggleNav: 'Basculer la navigation',
        mainNav: 'Navigation principale',
        selectLanguage: 'Sélectionner la langue',
        switchToLight: 'Passer en mode clair',
        switchToDark: 'Passer en mode sombre',
      },
      about: {
        role: 'Ingénieur Logiciel Frontend',
        bio1: "Expérience dans la conduite de projets complexes et transversaux depuis l'idéation jusqu'à la production à grande échelle.",
        viewExperience: "Voir l'expérience",
        getInTouch: 'Me contacter',
      },
      experience: {
        heading: 'Expérience',
        present: "Aujourd'hui",
        facebookTitle: 'Ingénieur Produit',
        otherExperience: 'Autre Expérience',
        getInTouch: 'Me contacter',
        personalPortfolio: 'Portefeuille personnel',
        portfolio: 'Ce site web!',
        moreDetails: 'Plus de détails',
        lessDetails: 'Moins de détails',
        uber: "Tech lead frontend de l'équipe développant des outils pour créer, tester et observer des flux automatisés par IA dans la suite d'applications Uber.",
        facebook: 'Développé et optimisé des flux permettant aux boutiques de présenter leurs produits sur la marketplace et dans les publications Facebook.',
        uberDetail1: "Chef de programme pour AutoPlay, l'outil d'observabilité unifié qui permet de découvrir, relire et déboguer les sessions de support client multi-surfaces et agnostiques de la plateforme sur l'ensemble de la suite d'applications",
        uberDetail2: 'Guidé la direction stratégique au niveau supérieur influençant la stratégie et les normes sur 30+ projets',
        uberDetail3: 'Effectué une migration progressive des détails de lecture et de débogage pour supporter les nouvelles technologies d\'exécution tout en maintenant la compatibilité descendante avec les automatisations déterministes héritées',
        uberDetail4: 'Multiplié l\'impact en migrant le code de lecture vers un plug-in de fusion réutilisable permettant à 6 autres projets de s\'intégrer sans problème',
        uberDetail5: "Conduit les mises à niveau de service, les processus d'oncall, les normes de conception de systèmes et le suivi des impacts pour améliorer le développement dans tous les projets",
        metaDetail1: 'Collaboré avec les équipes de conception, de science des données et d\'ingénierie chez Facebook pour débloquer les projets à grande échelle et exploiter les solutions collectives',
        metaDetail2: 'Effectué des expériences utilisateur avec des tests A/B en exploitant l\'infrastructure de journalisation et les considérations UX pour déterminer les résultats',
        metaDetail3: 'Gestion des fonctionnalités du stade de l\'idéation et de l\'évaluation des opportunités jusqu\'à la conception, le développement et la production',
        metaDetail4: 'Développé sur différentes bases de code incluant le backend (hack) web (react), mobile (react native) et ios (objective-c)',
        metaDetail5: "Architecturé l'abstraction de journalisation centrale pour notre équipe en assurant la cohérence des charges utiles et la facilité d'utilisation sur toutes les plates-formes et fonctionnalités",
        artInTheCape: "Conçu et architecturé un site e-commerce pour les achats de la galerie et la billetterie d'événements.",
        menten: "Développé des outils internes pour améliorer l'efficacité de l'équipe commerciale.",
        cleanSlate: 'Créé et maintenu un site web de conseil.',
        engineersWeek: "Développé et déployé un site web d'inscription et d'information.",
      },
      contact: {
        heading: 'Contact',
        intro: 'Matthew est toujours ouvert aux conversations intéressantes, aux collaborations ou aux nouvelles opportunités.',
        linkedin: 'LinkedIn',
        email: 'E-mail',
        github: 'GitHub',
        sendEmail: 'Envoyer un e-mail',
        visit: 'Visiter',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  de: {
    translation: {
      nav: { about: 'Über mich', experience: 'Erfahrung', contact: 'Kontakt' },
      aria: {
        toggleNav: 'Navigation umschalten',
        mainNav: 'Hauptnavigation',
        selectLanguage: 'Sprache auswählen',
        switchToLight: 'Zum hellen Modus wechseln',
        switchToDark: 'Zum dunklen Modus wechseln',
      },
      about: {
        role: 'Frontend-Softwareingenieur',
        bio1: 'Erfahrung in der Leitung komplexer, teamübergreifender Projekte von der frühen Ideenfindung bis zur Produktion in großem Maßstab.',
        viewExperience: 'Erfahrung ansehen',
        getInTouch: 'Kontakt aufnehmen',
      },
      experience: {
        heading: 'Erfahrung',
        present: 'Heute',
        facebookTitle: 'Produktingenieur',
        otherExperience: 'Weitere Erfahrung',
        getInTouch: 'Kontakt aufnehmen',
        personalPortfolio: 'Persönliches Portfolio',
        portfolio: 'Diese Website!',
        moreDetails: 'Weitere Details',
        lessDetails: 'Weniger Details',
        uber: 'Frontend Tech Lead des Teams, das Tools zur Erstellung, zum Testen und zur Beobachtung KI-gestützter automatisierter Abläufe in der Uber-App-Suite entwickelt.',
        facebook: 'Abläufe für Shops entwickelt und optimiert, um ihre Produkte im Marketplace und in Facebook-Beiträgen zu präsentieren.',
        uberDetail1: 'Programmleiter für AutoPlay, das einheitliche Observability-Tool, das das Entdecken, Wiedergeben und Debuggen von Multi-Surface-, plattformunabhängigen Kundenunterstützungssitzungen über die gesamte App-Suite hinweg ermöglicht',
        uberDetail2: 'Trieb die strategische Ausrichtung auf hoher Ebene voran und beeinflusste Strategie und Standards über 30+ Projekte',
        uberDetail3: 'Führte eine schrittweise Migration von Wiedergabe- und Debug-Details durch, um neue Ausführungstechnologien zu unterstützen und gleichzeitig die Rückwärtskompatibilität mit älteren deterministischen Automatisierungen zu wahren',
        uberDetail4: 'Vervielfachte die Auswirkungen, indem ich Wiedergabe-Code auf ein wiederverwendbares Fusion-Plugin migrierte, das es 6 anderen Projekten ermöglichte, sich nahtlos zu integrieren',
        uberDetail5: 'Trieb Service-Upgrades, Oncall-Prozesse, System-Design-Standards und Impact-Tracking voran, um die Entwicklung über alle Projekte hinweg zu verbessern',
        metaDetail1: 'Zusammenarbeit mit Design-, Data-Science- und Engineering-Teams bei Facebook, um großangelegte Projekte freizuschalten und Lösungen in der Gruppe zu finden',
        metaDetail2: 'Durchführung von Benutzerexperimenten mit A/B-Tests unter Nutzung der Protokollierungsinfrastruktur und UX-Überlegungen zur Bestimmung der Ergebnisse',
        metaDetail3: 'Verwaltung von Features von der Ideenfindung und Bewertung der Möglichkeiten bis hin zu Design, Entwicklung und Produktion',
        metaDetail4: 'Entwicklung über verschiedene Codebasen hinweg einschließlich Backend (Hack), Web (React), Mobile (React Native) und iOS (Objective-C)',
        metaDetail5: 'Architektiert die zentrale Protokollierungsabstraktion für unser Team und stellt Konsistenz der Payload und einfache Verwendung über alle Plattformen und Funktionen hinweg sicher',
        artInTheCape: 'E-Commerce-Website für Galeriekäufe und Veranstaltungstickets entworfen und architektonisch gestaltet.',
        menten: 'Interne Tools zur Steigerung der Effizienz des Vertriebsteams entwickelt.',
        cleanSlate: 'Beratungswebsite erstellt und gepflegt.',
        engineersWeek: 'Registrierungs- und Informationswebsite erstellt und bereitgestellt.',
      },
      contact: {
        heading: 'Kontakt',
        intro: 'Matthew ist immer offen für interessante Gespräche, Kooperationen oder neue Möglichkeiten.',
        linkedin: 'LinkedIn',
        email: 'E-Mail',
        github: 'GitHub',
        sendEmail: 'E-Mail senden',
        visit: 'Besuchen',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  pt: {
    translation: {
      nav: { about: 'Sobre', experience: 'Experiência', contact: 'Contato' },
      aria: {
        toggleNav: 'Alternar navegação',
        mainNav: 'Navegação principal',
        selectLanguage: 'Selecionar idioma',
        switchToLight: 'Mudar para modo claro',
        switchToDark: 'Mudar para modo escuro',
      },
      about: {
        role: 'Engenheiro de Software Frontend',
        bio1: 'Experiente em conduzir projetos complexos e multidisciplinares desde a idealização até a produção em escala.',
        viewExperience: 'Ver experiência',
        getInTouch: 'Entrar em contato',
      },
      experience: {
        heading: 'Experiência',
        present: 'Presente',
        facebookTitle: 'Engenheiro de Produto',
        otherExperience: 'Outra Experiência',
        getInTouch: 'Entrar em contato',
        personalPortfolio: 'Portfólio pessoal',
        portfolio: 'Este site!',
        moreDetails: 'Mais detalhes',
        lessDetails: 'Menos detalhes',
        uber: 'Tech lead frontend de equipe que desenvolve ferramentas para criar, testar e observar fluxos automatizados com IA na suite de aplicativos do Uber.',
        facebook: 'Desenvolveu e otimizou fluxos para que lojas exibissem seus produtos no marketplace e em publicações do Facebook.',
        uberDetail1: 'Líder de programa para AutoPlay, a ferramenta de observabilidade unificada que permite descobrir, reproduzir e depurar sessões de suporte ao cliente multi-superfície e agnósticas da plataforma em toda a suite de aplicativos',
        uberDetail2: 'Orientou a direção estratégica em alto nível, influenciando estratégia e padrões em 30+ projetos',
        uberDetail3: 'Realizou migração progressiva de detalhes de reprodução e depuração para suportar novas tecnologias de execução, mantendo compatibilidade com versões anteriores com automações determinísticas herdadas',
        uberDetail4: 'Multiplicou o impacto ao migrar o código de reprodução para um plug-in de fusão reutilizável, permitindo que 6 outros projetos se integrassem perfeitamente',
        uberDetail5: 'Impulsionou atualizações de serviço, processos de oncall, padrões de design de sistema e rastreamento de impacto para melhorar o desenvolvimento em todos os projetos',
        metaDetail1: 'Colaborou com equipes de design, ciência de dados e engenharia no Facebook para desbloquear projetos em larga escala e obter soluções coletivas',
        metaDetail2: 'Realizou experimentos do usuário com testes A/B aproveitando a infraestrutura de registro e considerações de UX para determinar os resultados',
        metaDetail3: 'Gerenciou recursos desde a ideação e dimensionamento de oportunidades até design, desenvolvimento e produção',
        metaDetail4: 'Desenvolvido em várias bases de código, incluindo backend (hack), web (react), mobile (react native) e ios (objective-c)',
        metaDetail5: 'Arquitetou a abstração central de registro para nossa equipe, garantindo consistência de carga útil e facilidade de uso em todas as plataformas e recursos',
        artInTheCape: 'Projetei e arquitetei um site de e-commerce para compras da galeria e venda de ingressos para eventos.',
        menten: 'Desenvolveu ferramentas internas para aumentar a eficiência da equipe de vendas.',
        cleanSlate: 'Criou e manteve um site de consultoria.',
        engineersWeek: 'Desenvolveu e implantou um site de registro e informações.',
      },
      contact: {
        heading: 'Contato',
        intro: 'Matthew está sempre aberto a conversas interessantes, colaborações ou novas oportunidades.',
        linkedin: 'LinkedIn',
        email: 'E-mail',
        github: 'GitHub',
        sendEmail: 'Enviar e-mail',
        visit: 'Visitar',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  ru: {
    translation: {
      nav: { about: 'Обо мне', experience: 'Опыт', contact: 'Контакты' },
      aria: {
        toggleNav: 'Переключить навигацию',
        mainNav: 'Основная навигация',
        selectLanguage: 'Выбрать язык',
        switchToLight: 'Светлая тема',
        switchToDark: 'Тёмная тема',
      },
      about: {
        role: 'Frontend-разработчик',
        bio1: 'Опыт ведения сложных межкомандных проектов от ранней концепции до масштабного производства.',
        viewExperience: 'Посмотреть опыт',
        getInTouch: 'Связаться',
      },
      experience: {
        heading: 'Опыт работы',
        present: 'н.в.',
        facebookTitle: 'Продуктовый инженер',
        otherExperience: 'Другой Опыт',
        getInTouch: 'Связаться',
        personalPortfolio: 'Личный портфель',
        portfolio: 'Этот сайт!',
        moreDetails: 'Подробнее',
        lessDetails: 'Меньше подробностей',
        uber: 'Технический лид фронтенда команды, разрабатывающей инструменты для создания, тестирования и мониторинга автоматизированных потоков на основе ИИ в приложениях Uber.',
        facebook: 'Разрабатывал и оптимизировал механизмы для отображения товаров магазинов на marketplace и в публикациях Facebook.',
        uberDetail1: 'Руководитель программы AutoPlay, унифицированного инструмента наблюдаемости, который позволяет обнаруживать, воспроизводить и отлаживать многоповерхностные, независимые от платформы сеансы поддержки клиентов во всем наборе приложений',
        uberDetail2: 'Определил стратегическое направление высокого уровня, влияя на стратегию и стандарты более чем 30 проектов',
        uberDetail3: 'Выполнил постепенную миграцию деталей воспроизведения и отладки для поддержки новых технологий выполнения при сохранении обратной совместимости с унаследованными детерминированными автоматизациями',
        uberDetail4: 'Умножил влияние, перенеся код воспроизведения на многоразовый плагин слияния, позволяющий 6 другим проектам беспрепятственно интегрироваться',
        uberDetail5: 'Стимулировал обновления услуг, процессы oncall, стандарты проектирования системы и отслеживание влияния для улучшения разработки во всех проектах',
        metaDetail1: 'Сотрудничал с командами дизайна, науки о данных и инженерии в Facebook для разблокировки крупномасштабных проектов и поиска коллективных решений',
        metaDetail2: 'Проводил пользовательские эксперименты с A/B-тестированием, используя инфраструктуру логирования и соображения UX для определения результатов',
        metaDetail3: 'Управлял функциями от идеи и оценки возможностей через дизайн и разработку до производства',
        metaDetail4: 'Разработано на различных кодовых базах, включая backend (hack), web (react), mobile (react native) и ios (objective-c)',
        metaDetail5: 'Архитектировал центральную абстракцию логирования для нашей команды, обеспечивая согласованность полезной нагрузки и простоту использования на всех платформах и функциях',
        artInTheCape: 'Спроектировал и архитектурировал веб-сайт электронной коммерции для покупок в галерее и продажи билетов на мероприятия.',
        menten: 'Разработал внутренние инструменты для повышения эффективности отдела продаж.',
        cleanSlate: 'Создал и поддерживал консалтинговый сайт.',
        engineersWeek: 'Разработал и развернул сайт для регистрации и информирования.',
      },
      contact: {
        heading: 'Контакты',
        intro: 'Мэтью всегда открыт для интересных разговоров, сотрудничества или новых возможностей.',
        linkedin: 'LinkedIn',
        email: 'Электронная почта',
        github: 'GitHub',
        sendEmail: 'Написать письмо',
        visit: 'Перейти',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  zh: {
    translation: {
      nav: { about: '关于', experience: '经历', contact: '联系' },
      aria: {
        toggleNav: '切换导航',
        mainNav: '主导航',
        selectLanguage: '选择语言',
        switchToLight: '切换到浅色模式',
        switchToDark: '切换到深色模式',
      },
      about: {
        role: '前端软件工程师',
        bio1: '具有丰富的经验，能够将复杂的跨团队项目从早期构思推进至大规模生产。',
        viewExperience: '查看经历',
        getInTouch: '联系我',
      },
      experience: {
        heading: '工作经历',
        present: '至今',
        facebookTitle: '产品工程师',
        otherExperience: '其他经历',
        getInTouch: '联系我',
        personalPortfolio: '个人作品集',
        portfolio: '这个网站！',
        moreDetails: '更多详情',
        lessDetails: '较少详情',
        uber: '担任团队前端技术负责人，负责开发用于创作、测试和观察 Uber 应用程序套件中 AI 驱动自动化流程的工具。',
        facebook: '构建并优化商店在 Marketplace 和 Facebook 帖子上展示产品的流程。',
        uberDetail1: 'AutoPlay 项目主管，这是一个统一的可观测性工具，可以在整个应用程序套件中发现、回放和调试多表面、平台不可知的客户支持会话',
        uberDetail2: '推动高层战略方向，影响 30 多个项目的战略和标准',
        uberDetail3: '执行了回放和调试详细信息的渐进式迁移，以支持新的执行技术，同时保持与旧版确定性自动化的向后兼容性',
        uberDetail4: '通过将回放代码迁移到可重用的融合插件，实现了影响倍增，使其他 6 个项目能够无缝集成',
        uberDetail5: '推动服务升级、oncall 流程、系统设计标准和影响跟踪，以增强所有项目的开发',
        metaDetail1: '与 Facebook 的设计、数据科学和工程团队合作，以解锁大规模项目并汇集解决方案',
        metaDetail2: '通过利用日志记录基础设施和用户体验考虑因素进行 A/B 测试，进行用户实验以确定结果',
        metaDetail3: '从构思和机会规模到设计、开发和生产的全过程管理功能',
        metaDetail4: '在多个代码库上进行开发，包括后端 (hack)、web (react)、mobile (react native) 和 ios (objective-c)',
        metaDetail5: '为我们的团队架构了核心日志记录抽象，确保有效负载一致性和跨所有平台和功能的易用性',
        artInTheCape: '设计并构建了一个电商网站架构，用于画廊购买和活动售票。',
        menten: '开发内部工具以提升销售团队的工作效率。',
        cleanSlate: '创建并维护了一个咨询网站。',
        engineersWeek: '构建并部署了注册与信息展示网站。',
      },
      contact: {
        heading: '联系',
        intro: 'Matthew 始终欢迎有趣的对话、合作或新的机会。',
        linkedin: 'LinkedIn',
        email: '电子邮件',
        github: 'GitHub',
        sendEmail: '发送邮件',
        visit: '访问',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  ja: {
    translation: {
      nav: { about: '概要', experience: '経歴', contact: 'お問い合わせ' },
      aria: {
        toggleNav: 'ナビゲーションを切り替え',
        mainNav: 'メインナビゲーション',
        selectLanguage: '言語を選択',
        switchToLight: 'ライトモードに切り替え',
        switchToDark: 'ダークモードに切り替え',
      },
      about: {
        role: 'フロントエンドソフトウェアエンジニア',
        bio1: '複雑なクロスチームプロジェクトを初期のアイデア段階から大規模な本番環境への展開まで主導した豊富な経験があります。',
        viewExperience: '経歴を見る',
        getInTouch: 'お問い合わせ',
      },
      experience: {
        heading: '経歴',
        present: '現在',
        facebookTitle: 'プロダクトエンジニア',
        otherExperience: 'その他の経験',
        getInTouch: 'お問い合わせ',
        personalPortfolio: 'ポートフォリオ',
        portfolio: 'このウェブサイト！',
        moreDetails: 'さらに詳しく',
        lessDetails: '詳細を少なく',
        uber: 'UberアプリスイートでAI活用の自動化フローを作成・テスト・監視するツールを開発するチームのフロントエンドテックリード。',
        facebook: 'ショップがMarketplaceとFacebookポストで製品を紹介するためのフローを構築・最適化。',
        uberDetail1: 'AutoPlayのプログラムリード。アプリスイート全体でマルチサーフェス、プラットフォーム非依存のカスタマーサポートセッションの発見、再生、デバッグを可能にする統一された可観測性ツール',
        uberDetail2: '30以上のプロジェクト全体の戦略と標準に影響を与えながら、高レベルのプラットフォーム方向を推進',
        uberDetail3: '新しい実行テクノロジーをサポートするための再生およびデバッグの詳細の段階的な移行を実行しながら、レガシー決定論的自動化との下位互換性を維持',
        uberDetail4: '再生コードを再利用可能なフュージョンプラグインに移行することで影響を倍増させ、他の6つのプロジェクトがシームレスに統合できるようにしました',
        uberDetail5: 'サービスのアップグレード、オンコール プロセス、システム設計標準、影響追跡を推進して、すべてのプロジェクト全体の開発を強化',
        metaDetail1: 'Facebookのデザイン、データサイエンス、エンジニアリングチームと協力して、大規模なプロジェクトのロックを解除し、ソリューションを集約',
        metaDetail2: 'ロギングインフラストラクチャとUX上の考慮事項を活用したA/Bテストを使用してユーザー実験を実施し、結果を決定',
        metaDetail3: 'アイデア出し、機会評価からデザイン、開発、本番まで、すべての段階で機能を管理',
        metaDetail4: 'バックエンド（ハック）、ウェブ（リアクト）、モバイル（リアクトネイティブ）、iOS（Objective-C）を含む様々なコードベースで開発',
        metaDetail5: 'チームのコアロギング抽象化を設計し、すべてのプラットフォームと機能全体でペイロードの一貫性と使いやすさを確保',
        artInTheCape: 'ギャラリー購入とイベントチケット販売向けのECサイトを設計・構築。',
        menten: '営業チームの効率を高めるための社内ツールを開発。',
        cleanSlate: 'コンサルティングWebサイトを作成・維持。',
        engineersWeek: '登録・情報提供Webサイトを構築・デプロイ。',
      },
      contact: {
        heading: 'お問い合わせ',
        intro: 'Matthewは、興味深い会話、コラボレーション、または新しい機会に常にオープンです。',
        linkedin: 'LinkedIn',
        email: 'メール',
        github: 'GitHub',
        sendEmail: 'メールを送る',
        visit: '訪問する',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  ko: {
    translation: {
      nav: { about: '소개', experience: '경력', contact: '연락처' },
      aria: {
        toggleNav: '탐색 전환',
        mainNav: '주요 탐색',
        selectLanguage: '언어 선택',
        switchToLight: '라이트 모드로 전환',
        switchToDark: '다크 모드로 전환',
      },
      about: {
        role: '프론트엔드 소프트웨어 엔지니어',
        bio1: '초기 기획 단계부터 대규모 프로덕션 출시까지 복잡한 크로스팀 프로젝트를 주도한 풍부한 경험이 있습니다.',
        viewExperience: '경력 보기',
        getInTouch: '연락하기',
      },
      experience: {
        heading: '경력',
        present: '현재',
        facebookTitle: '프로덕트 엔지니어',
        otherExperience: '기타 경력',
        getInTouch: '연락하기',
        personalPortfolio: '개인 포트폴리오',
        portfolio: '이 웹사이트!',
        moreDetails: '더 많은 세부정보',
        lessDetails: '더 적은 세부정보',
        uber: 'Uber 앱 스위트 전반에 걸쳐 AI 기반 자동화 흐름을 작성, 테스트, 모니터링하는 도구를 개발하는 팀의 프론트엔드 테크 리드.',
        facebook: '쇼핑몰이 마켓플레이스와 Facebook 게시물에서 상품을 선보일 수 있는 플로우를 구축하고 최적화.',
        uberDetail1: 'AutoPlay 프로그램 리드로서, 전체 앱 스위트 전체에서 다중 표면, 플랫폼 불가지론적 고객 지원 세션의 검색, 재생 및 디버깅을 가능하게 하는 통합 관찰 가능성 도구',
        uberDetail2: '30개 이상의 프로젝트 전체에 걸쳐 전략과 표준에 영향을 미치는 높은 수준의 플랫폼 방향 주도',
        uberDetail3: '새로운 실행 기술을 지원하는 동시에 레거시 결정론적 자동화와의 하위 호환성을 유지하면서 재생 및 디버깅 세부 사항의 점진적 마이그레이션 수행',
        uberDetail4: '재생 코드를 재사용 가능한 융합 플러그인으로 마이그레이션하여 영향력을 배가했으며 6개의 다른 프로젝트가 완벽하게 통합할 수 있도록 함',
        uberDetail5: '서비스 업그레이드, 온콜 프로세스, 시스템 설계 표준 및 영향 추적을 추진하여 모든 프로젝트 전반의 개발 향상',
        metaDetail1: 'Facebook의 디자인, 데이터 과학 및 엔지니어링 팀과 협력하여 대규모 프로젝트의 잠금을 해제하고 집단 솔루션 활용',
        metaDetail2: '로깅 인프라 및 UX 고려 사항을 활용한 A/B 테스트를 사용하여 사용자 실험 수행 및 결과 결정',
        metaDetail3: '아이디어 출현 및 기회 규모 조정부터 설계, 개발 및 프로덕션까지 기능 관리',
        metaDetail4: '백엔드(해킹), 웹(리액트), 모바일(리액트 네이티브) 및 iOS(Objective-C)를 포함한 다양한 코드베이스에서 개발',
        metaDetail5: '팀의 핵심 로깅 추상화를 설계하여 모든 플랫폼 및 기능 전체에서 페이로드 일관성 및 사용 용이성 보장',
        artInTheCape: '갤러리 구매 및 이벤트 티켓팅을 위한 이커머스 웹사이트 설계 및 아키텍처.',
        menten: '영업팀의 효율을 높이기 위한 내부 도구 개발.',
        cleanSlate: '컨설팅 웹사이트 구축 및 유지보수.',
        engineersWeek: '등록 및 정보 제공 웹사이트 구축 및 배포.',
      },
      contact: {
        heading: '연락처',
        intro: 'Matthew는 항상 흥미로운 대화, 협업 또는 새로운 기회에 열려 있습니다.',
        linkedin: 'LinkedIn',
        email: '이메일',
        github: 'GitHub',
        sendEmail: '이메일 보내기',
        visit: '방문하기',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  ar: {
    translation: {
      nav: { about: 'نبذة عني', experience: 'الخبرة', contact: 'التواصل' },
      aria: {
        toggleNav: 'تبديل التنقل',
        mainNav: 'التنقل الرئيسي',
        selectLanguage: 'اختر اللغة',
        switchToLight: 'التبديل إلى الوضع الفاتح',
        switchToDark: 'التبديل إلى الوضع الداكن',
      },
      about: {
        role: 'مهندس برمجيات واجهة أمامية',
        bio1: 'خبرة في قيادة مشاريع متعددة الفرق من مرحلة الفكرة الأولى حتى الإطلاق على نطاق واسع.',
        viewExperience: 'عرض الخبرة',
        getInTouch: 'تواصل معي',
      },
      experience: {
        heading: 'الخبرة',
        present: 'حتى الآن',
        facebookTitle: 'مهندس منتجات',
        otherExperience: 'خبرات أخرى',
        getInTouch: 'تواصل معي',
        portfolio: 'هذا الموقع!',
        moreDetails: 'المزيد من التفاصيل',
        lessDetails: 'تفاصيل أقل',
        uber: 'قائد تقني للواجهة الأمامية للفريق المطوِّر لأدوات إنشاء واختبار ومراقبة التدفقات الآلية المدعومة بالذكاء الاصطناعي عبر مجموعة تطبيقات أوبر.',
        facebook: 'بناء وتحسين مسارات تمكين المتاجر من عرض منتجاتهم على السوق وفي منشورات فيسبوك.',
        uberDetail1: 'قائد البرنامج لـ AutoPlay، أداة القابلية للمراقبة الموحدة التي تمكن من اكتشاف وتشغيل وتصحيح جلسات دعم العملاء متعددة الأسطح والمستقلة عن المنصة عبر مجموعة التطبيقات',
        uberDetail2: 'قيادة اتجاه منصة عالي المستوى يؤثر على الاستراتيجية والمعايير عبر 30+ مشروع',
        uberDetail3: 'تنفيذ ترحيل تدريجي لتفاصيل التشغيل والتصحيح لدعم تقنيات التنفيذ الجديدة مع الحفاظ على التوافق العكسي مع الأتمتة الحتمية الموروثة',
        uberDetail4: 'مضاعفة الفرصة بترحيل رمز التشغيل إلى مكون اندماج قابل لإعادة الاستخدام مما يمكّن 6 مشاريع أخرى من الدمج بسلاسة',
        uberDetail5: 'قيادة ترقيات الخدمة وعمليات oncall ومعايير تصميم النظام وتتبع التأثير لتحسين التطوير عبر المشاريع',
        metaDetail1: 'التعاون مع فريق التصميم وعلم البيانات والهندسة في Facebook لفتح المشاريع واسعة النطاق والاستفادة من الحلول الجماعية',
        metaDetail2: 'إجراء تجارب المستخدم باستخدام الاختبار أ/ب مع الاستفادة من بنية تسجيل الدخول واعتبارات تجربة المستخدم لتحديد النتائج',
        metaDetail3: 'إدارة الميزات من الحدس والتقدير الفرصة من خلال التصميم والتطوير والإنتاج',
        metaDetail4: 'تم التطوير عبر قواعد رمز مختلفة بما في ذلك الواجهة الخلفية (hack) والويب (react) والجوال (react native) و ios (objective-c)',
        metaDetail5: 'بناء بنية معمارية للملخص المركزي لسجل فريقنا مما يضمن اتساق الحمولة وسهولة الاستخدام عبر جميع المنصات والميزات',
        artInTheCape: 'تصميم وهندسة موقع تجارة إلكترونية لمشتريات المعرض وبيع تذاكر الفعاليات.',
        menten: 'تطوير أدوات داخلية لتحسين كفاءة فريق المبيعات.',
        cleanSlate: 'إنشاء وصيانة موقع استشاري.',
        engineersWeek: 'بناء ونشر موقع تسجيل ومعلومات.',
      },
      contact: {
        heading: 'التواصل',
        intro: 'ماثيو منفتح دائمًا على المحادثات المثيرة للاهتمام والتعاون والفرص الجديدة.',
        linkedin: 'LinkedIn',
        email: 'البريد الإلكتروني',
        github: 'GitHub',
        sendEmail: 'إرسال بريد إلكتروني',
        visit: 'زيارة',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  hi: {
    translation: {
      nav: { about: 'परिचय', experience: 'अनुभव', contact: 'संपर्क' },
      aria: {
        toggleNav: 'नेविगेशन टॉगल करें',
        mainNav: 'मुख्य नेविगेशन',
        selectLanguage: 'भाषा चुनें',
        switchToLight: 'लाइट मोड में जाएं',
        switchToDark: 'डार्क मोड में जाएं',
      },
      about: {
        role: 'फ्रंटेंड सॉफ्टवेयर इंजीनियर',
        bio1: 'जटिल, क्रॉस-टीम परियोजनाओं को प्रारंभिक विचार से लेकर बड़े पैमाने पर उत्पादन तक ले जाने का अनुभव।',
        viewExperience: 'अनुभव देखें',
        getInTouch: 'संपर्क करें',
      },
      experience: {
        heading: 'अनुभव',
        present: 'वर्तमान',
        facebookTitle: 'प्रोडक्ट इंजीनियर',
        otherExperience: 'अन्य अनुभव',
        getInTouch: 'संपर्क करें',
        personalPortfolio: 'व्यक्तिगत पोर्टफोलियो',
        portfolio: 'यह वेबसाइट!',
        moreDetails: 'अधिक विवरण',
        lessDetails: 'कम विवरण',
        uber: 'Uber ऐप्स में AI-संचालित स्वचालित प्रवाहों को बनाने, परखने और देखने के लिए उपकरण विकसित करने वाली टीम के फ्रंटेंड तकनीकी प्रमुख।',
        facebook: 'दुकानों को मार्केटप्लेस और फेसबुक पोस्ट पर अपने उत्पाद दिखाने के लिए प्रवाह बनाए और अनुकूलित किए।',
        uberDetail1: 'AutoPlay के लिए कार्यक्रम नेता, एक एकीकृत अवलोकनीयता उपकरण जो ऐप्स के पूरे सूट में बहु-सतह, प्लेटफॉर्म-अज्ञेय ग्राहक समर्थन सत्रों की खोज, प्लेबैक और डीबगिंग सक्षम करता है',
        uberDetail2: '30+ परियोजनाओं में कौशल और मानकों को प्रभावित करते हुए उच्च स्तरीय मंच दिशा संचालित करें',
        uberDetail3: 'विरासत निर्धारणवादी ऑटोमेशन के साथ पिछड़े संगतता बनाए रखते हुए नई निष्पादन प्रौद्योगिकियों का समर्थन करने के लिए प्लेबैक और डीबगिंग विवरण का प्रगतिशील माइग्रेशन प्रदर्शन',
        uberDetail4: 'प्लेबैक कोड को एक पुन: प्रयोज्य संलयन प्लगइन में स्थानांतरित करके प्रभाव को गुणा किया, 6 अन्य परियोजनाओं को निरंतर एकीकरण सक्षम किया',
        uberDetail5: 'सेवा अपग्रेड, ऑनकॉल प्रक्रियाएं, सिस्टम डिजाइन मानक और प्रभाव ट्रैकिंग चलाई सभी परियोजनाओं में विकास को बढ़ाने के लिए',
        metaDetail1: 'Facebook में डिजाइन, डेटा विज्ञान और इंजीनियरिंग टीमों के साथ सहयोग किया बड़े पैमाने पर परियोजनाओं को अनलॉक करने और सामूहिक समाधान का लाभ उठाने के लिए',
        metaDetail2: 'लॉगिंग इंफ्रास्ट्रक्चर और यूएक्स विचारों का लाभ उठाते हुए ए/बी परीक्षण के साथ उपयोगकर्ता प्रयोग प्रदर्शन किए परिणाम निर्धारित करने के लिए',
        metaDetail3: 'विचार से अवसर आकार निर्धारण से डिजाइन, विकास और उत्पादन के माध्यम से सुविधाएं प्रबंधित करें',
        metaDetail4: 'बैकएंड (हैक), वेब (प्रतिक्रिया), मोबाइल (प्रतिक्रिया मूल) और iOS (उद्देश्य-सी) सहित विभिन्न कोडबेस पर विकसित',
        metaDetail5: 'हमारी टीम के लिए कोर लॉगिंग अब्स्ट्रक्शन का आर्किटेक्ट सभी प्लेटफॉर्म और सुविधाओं में पेलोड संगति और उपयोग में आसानी सुनिश्चित करना',
        artInTheCape: 'गैलरी खरीदारी और इवेंट टिकटिंग के लिए एक ई-कॉमर्स वेबसाइट डिजाइन और आर्किटेक्ट किया।',
        menten: 'बिक्री टीम की दक्षता बढ़ाने के लिए आंतरिक उपकरण बनाए।',
        cleanSlate: 'एक परामर्श वेबसाइट बनाई और बनाए रखी।',
        engineersWeek: 'पंजीकरण और सूचनात्मक वेबसाइट बनाई और तैनात की।',
      },
      contact: {
        heading: 'संपर्क',
        intro: 'Matthew हमेशा दिलचस्प बातचीत, सहयोग या नए अवसरों के लिए तैयार रहते हैं।',
        linkedin: 'LinkedIn',
        email: 'ईमेल',
        github: 'GitHub',
        sendEmail: 'ईमेल भेजें',
        visit: 'जाएँ',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
  bn: {
    translation: {
      nav: { about: 'পরিচয়', experience: 'অভিজ্ঞতা', contact: 'যোগাযোগ' },
      aria: {
        toggleNav: 'নেভিগেশন টগল করুন',
        mainNav: 'প্রধান নেভিগেশন',
        selectLanguage: 'ভাষা নির্বাচন করুন',
        switchToLight: 'লাইট মোডে যান',
        switchToDark: 'ডার্ক মোডে যান',
      },
      about: {
        role: 'ফ্রন্টেন্ড সফটওয়্যার ইঞ্জিনিয়ার',
        bio1: 'জটিল, ক্রস-টিম প্রকল্পগুলিকে প্রাথমিক ধারণা থেকে বড় পরিসরে উৎপাদনে নিয়ে যাওয়ার অভিজ্ঞতা।',
        viewExperience: 'অভিজ্ঞতা দেখুন',
        getInTouch: 'যোগাযোগ করুন',
      },
      experience: {
        heading: 'অভিজ্ঞতা',
        present: 'বর্তমান',
        facebookTitle: 'প্রোডাক্ট ইঞ্জিনিয়ার',
        otherExperience: 'অন্যান্য অভিজ্ঞতা',
        getInTouch: 'যোগাযোগ করুন',
        personalPortfolio: 'ব্যক্তিগত পোর্টফোলিও',
        portfolio: 'এই ওয়েবসাইট!',
        moreDetails: 'আরও বিবরণ',
        lessDetails: 'কম বিস্তারিত',
        uber: 'Uber অ্যাপের সুইটে AI-চালিত স্বয়ংক্রিয় প্রবাহ তৈরি, পরীক্ষা এবং পর্যবেক্ষণের জন্য সরঞ্জাম তৈরিকারী দলের ফ্রন্টএন্ড প্রযুক্তি প্রধান।',
        facebook: 'দোকানগুলিকে মার্কেটপ্লেস এবং Facebook পোস্টে তাদের পণ্য প্রদর্শনের জন্য ফ্লো তৈরি এবং অপ্টিমাইজ করা।',
        uberDetail1: 'AutoPlay এর জন্য প্রোগ্রাম লিড, একটি একীভূত পর্যবেক্ষণযোগ্যতা সরঞ্জাম যা সম্পূর্ণ অ্যাপ স্যুট জুড়ে মাল্টি-সারফেস, প্ল্যাটফর্ম-অজ্ঞাতবাদী গ্রাহক সহায়তা সেশন আবিষ্কার, প্লেব্যাক এবং ডিবাগ করতে সক্ষম করে',
        uberDetail2: '30+ প্রকল্প জুড়ে কৌশল এবং মান প্রভাবিত করে উচ্চ স্তরের প্ল্যাটফর্ম দিক চালিত',
        uberDetail3: 'নতুন এক্সিকিউশন প্রযুক্তি সমর্থন করার জন্য প্লেব্যাক এবং ডিবাগিং বিবরণের প্রগতিশীল মাইগ্রেশন বাস্তবায়ন যখন উত্তরাধিকার নির্ধারক অটোমেশন সঙ্গে ব্যাকওয়ার্ড সামঞ্জস্য বজায়',
        uberDetail4: 'প্লেব্যাক কোড একটি পুনরায় ব্যবহারযোগ্য সংমিশ্রণ প্লাগইনে মাইগ্রেট করে প্রভাব বহুগুণ, 6 অন্যান্য প্রকল্প নির্বিঘ্নে সংহত করতে সক্ষমকরণ',
        uberDetail5: 'সেবা আপগ্রেড, অনকল প্রক্রিয়া, সিস্টেম ডিজাইন মান এবং প্রভাব ট্র্যাকিং চালিত সব প্রকল্প জুড়ে উন্নয়ন উন্নত',
        metaDetail1: 'Facebook এ ডিজাইন, ডেটা বিজ্ঞান এবং ইঞ্জিনিয়ারিং দল সঙ্গে সহযোগিতা বড় আকারের প্রকল্প আনলক এবং সম্মিলিত সমাধান কাজে লাগাতে',
        metaDetail2: 'লগিং অবকাঠামো এবং UX বিবেচনা লিভারেজ A/B পরীক্ষা সঙ্গে ব্যবহারকারী পরীক্ষা পরিচালনা ফলাফল নির্ধারণ',
        metaDetail3: 'ধারণা এবং সুযোগ মাপকাঠি থেকে ডিজাইন, উন্নয়ন এবং উৎপাদন মাধ্যমে বৈশিষ্ট্য পরিচালনা',
        metaDetail4: 'ব্যাকএন্ড (হ্যাক), ওয়েব (প্রতিক্রিয়া), মোবাইল (প্রতিক্রিয়া নেটিভ) এবং iOS (উদ্দেশ্য-C) সহ বিভিন্ন কোডবেস জুড়ে উন্নত',
        metaDetail5: 'আমাদের দল জন্য কোর লগিং বিমূর্ততা স্থপত্য সব প্ল্যাটফর্ম এবং বৈশিষ্ট্য জুড়ে পেলোড সামঞ্জস্য এবং ব্যবহার সহজ নিশ্চিত',
        artInTheCape: 'গ্যালারি কেনাকাটা এবং ইভেন্ট টিকিটিংয়ের জন্য একটি ই-কমার্স ওয়েবসাইট ডিজাইন এবং আর্কিটেক্ট করা।',
        menten: 'বিক্রয় দলের দক্ষতা বাড়াতে অভ্যন্তরীণ সরঞ্জাম তৈরি।',
        cleanSlate: 'একটি পরামর্শ ওয়েবসাইট তৈরি ও রক্ষণাবেক্ষণ।',
        engineersWeek: 'নিবন্ধন ও তথ্যমূলক ওয়েবসাইট তৈরি ও স্থাপন।',
      },
      contact: {
        heading: 'যোগাযোগ',
        intro: 'Matthew সবসময় আকর্ষণীয় কথোপকথন, সহযোগিতা বা নতুন সুযোগের জন্য উন্মুক্ত।',
        linkedin: 'LinkedIn',
        email: 'ইমেইল',
        github: 'GitHub',
        sendEmail: 'ইমেইল পাঠান',
        visit: 'পরিদর্শন করুন',
      },
      footer: { copyright: '© {{year}} Matthew Bluestein' },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
